import React from 'react';
import { convert2CompressedUrl } from '@shakkerai/util-image';
import cs from 'classnames';
import { useProjectState } from '@starflow/app/store';
import { getProcessor } from '@starflow/app/helpers/flow';
import xingliuLogo from '@starflow/app/assets/xingliu-logo.svg';
import BindBg from '../../assets/bind.svg';
import LabelEditer from '../../../../LabelEditer';
import FlowNodeIcon from '../../../../FlowNodeIcon';
import FlowNodeStatus from '../../../../FlowNodeStatus';
import { registerType } from '../../../../../../../constants';
import Handler from '../Hander';
import { translate } from '@shakkerai/util-i18n';

const IMGE_H = 70;
const NodeBaseLayout = ({ data, children, isConnectable }) => {
  const autoRunningFlowId = useProjectState('autoRunningFlowId');
  const autoRunningFlowNodeId = useProjectState('autoRunningFlowNodeId');
  const currentNodeId = useProjectState('currentNodeId');

  const isSelected = currentNodeId === data.id;
  const isAutoRunning = data.id === autoRunningFlowNodeId;
  const handleClick = () => {
    const processor = getProcessor(data.type);

    if (autoRunningFlowId === data.flowId) {
      return;
    }

    if (processor?.onNodeClick) {
      processor.onNodeClick(data);
    }
  };
  const { targethandlers, sourcehandlers, id } = data;

  return (
    <div className="flex items-start" onClick={handleClick}>
      <img src={BindBg} alt="" className="w-[14px] h-[20px] absolute left-[148px] top-[7px]" />
      <div
        className={cs(
          'w-[150px] relative rounded-[3px] border-solid border-[1px] px-[10px] mr-[10px] bg-white',
          isSelected ? 'border-primary bg-[#F5F9FF]' : 'border-[#e9eef2]',
        )}
      >
        <div className="w-full h-[34px] flex items-center" data-type={registerType.FLOW} data-id={data.id}>
          <FlowNodeIcon type={data.type} isSelected={isSelected} />
          <label htmlFor="text" className="text-xs ml-2 cursor-pointer">
            <LabelEditer data={data} type={registerType.FLOW} />
          </label>
          {isSelected && <FlowNodeStatus text={translate('flow_edit')} />}
          {isAutoRunning && <FlowNodeStatus text={translate('flow_runing')} />}
        </div>
        {children}
        <Handler
          targethandlers={targethandlers}
          sourcehandlers={sourcehandlers}
          isConnectable={isConnectable}
          data={data}
          IMGE_H={IMGE_H}
          isSelected={isSelected}
        />
      </div>
      <div
        className={cs(
          'relative w-[52px] bg-[#ffffff] p-[5px] rounded-[3px] border-solid border-[#E8EEF2] border-[1px]',
          `h-[${IMGE_H}px]`,
        )}
      >
        {data.result?.url ? (
          <img src={convert2CompressedUrl(data.result?.url, 100)} alt="" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-[#F8F9FA] flex items-center justify-center">
            <img src={xingliuLogo} alt="xingliu" className="w-[20px] h-[12px]" />
          </div>
        )}
      </div>
    </div>
  );
};

export default NodeBaseLayout;
